import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEmptyPaState = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={48}
    height={48}
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="#F5F5F5"
      stroke="#B2B2B2"
      strokeWidth={1.5}
      d="M23.37 4.204a.876.876 0 0 1 1.26 0l2.665 2.766c.61.633 1.521.878 2.367.634l3.69-1.062a.875.875 0 0 1 1.092.63l.925 3.726a2.37 2.37 0 0 0 1.733 1.734l3.727.925c.481.12.767.615.63 1.091l-1.062 3.69c-.244.846 0 1.757.633 2.368l2.766 2.664a.876.876 0 0 1 0 1.26l-2.766 2.665a2.38 2.38 0 0 0-.633 2.367l1.062 3.69a.875.875 0 0 1-.63 1.091v.001l-3.727.924c-.854.212-1.52.88-1.733 1.734l-.925 3.727a.875.875 0 0 1-1.002.65l-.09-.02-3.69-1.062a2.37 2.37 0 0 0-2.367.633l-2.664 2.766a.876.876 0 0 1-1.26 0l-2.666-2.766a2.38 2.38 0 0 0-2.367-.633l-3.69 1.062a.875.875 0 0 1-1.091-.63l-.925-3.727a2.38 2.38 0 0 0-1.733-1.734l-3.727-.924a.874.874 0 0 1-.63-1.092l1.062-3.69a2.38 2.38 0 0 0-.634-2.367L4.204 24.63a.876.876 0 0 1 0-1.26l2.766-2.665c.634-.61.878-1.522.634-2.368l-1.062-3.69a.875.875 0 0 1 .63-1.091l3.726-.925a2.38 2.38 0 0 0 1.734-1.734l.925-3.726a.875.875 0 0 1 1.091-.63l3.69 1.062c.846.244 1.757 0 2.368-.634z"
    />
    <path
      fill="#F5F5F5"
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22.83 3.684a1.625 1.625 0 0 1 2.34 0l2.665 2.766c.418.433 1.041.6 1.62.434l3.69-1.063a1.625 1.625 0 0 1 2.027 1.17l.925 3.727c.145.585.6 1.041 1.185 1.186l3.728.925a1.625 1.625 0 0 1 1.17 2.027l-1.063 3.69c-.167.579 0 1.202.434 1.62l2.766 2.664c.663.64.663 1.701 0 2.34l-2.766 2.665a1.63 1.63 0 0 0-.434 1.62l1.063 3.69a1.625 1.625 0 0 1-1.17 2.027l-3.727.924a1.63 1.63 0 0 0-1.186 1.186l-.925 3.728a1.625 1.625 0 0 1-2.027 1.17l-3.69-1.063a1.62 1.62 0 0 0-1.62.434l-2.665 2.765a1.625 1.625 0 0 1-2.34 0l-2.664-2.765a1.63 1.63 0 0 0-1.62-.434l-3.69 1.063a1.625 1.625 0 0 1-2.027-1.17l-.925-3.728a1.63 1.63 0 0 0-1.186-1.186l-3.727-.924a1.625 1.625 0 0 1-1.17-2.027l1.063-3.69c.166-.579 0-1.202-.434-1.62L3.684 25.17a1.625 1.625 0 0 1 0-2.34l2.766-2.664c.433-.418.6-1.041.434-1.62l-1.063-3.69a1.625 1.625 0 0 1 1.17-2.027l3.727-.925a1.63 1.63 0 0 0 1.186-1.186l.925-3.727a1.625 1.625 0 0 1 2.027-1.17l3.69 1.063c.579.166 1.202 0 1.62-.434z"
    />
    <path
      stroke="#B2B2B2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.733 35.375a.812.812 0 1 0 0-1.626M23.546 35.375a.812.812 0 1 1 0-1.626M18.046 19.937a5.687 5.687 0 1 1 5.687 5.688v3.25"
    />
  </svg>
);
export default SvgEmptyPaState;
